import React from "react";
import PropTypes from "kf-proptypes/account";
import { t, Trans } from "@lingui/macro";

import { ErrorBoundary } from "widgets/layouts";
import { Button, BUTTON_SIZES, BUTTON_TYPES } from "widgets/inputs";
import { KfIcon, KF_ICONS, ICON_SIZE, ICON_STROKE } from "widgets/kficon";

import styles from "./settingsWrap.css";

export function SettingsWrap(props) {
  const {
    onSave,
    // onCancel,
    header,
    children,
    isSaveDisabled,
    isSaveLoading,
    goBack,
    settingsWrapper,
    layoutTwo = false,
    saveBtnTxt = t`Save`,
    layoutThree = false
  } = props;
  return (
    <ErrorBoundary>
      <div
        className={`shadow-8dp ${styles.options} ${
          settingsWrapper ? settingsWrapper : ""
        } ${layoutTwo && styles.layoutTwo} ${
          layoutThree && styles.layoutThree
        }`}
      >
        <div className={`h5600 ${styles.header}`}>
          {goBack && (
            <KfIcon
              icon={KF_ICONS.ARROW_LEFT}
              size={ICON_SIZE.SIZE_16}
              stroke={ICON_STROKE.MEDIUM}
            />
          )}
          {header}
        </div>
        <div className={`${styles.childWrapper}`}>
          <div className={styles.bodyWrap}>{children}</div>
        </div>
        {onSave && (
          <div className={`${styles.footer}`}>
            {/* <div className={styles.flexSpace} /> */}
            <div className={styles.footerBtnWrapper}>
              {goBack && (
                <Button
                  type={BUTTON_TYPES.SECONDARY}
                  size={BUTTON_SIZES.BASE}
                  onClick={goBack}
                >
                  <Trans>Cancel</Trans>
                </Button>
              )}
              <Button
                size={BUTTON_SIZES.BASE}
                onClick={onSave}
                disabled={isSaveDisabled || isSaveLoading}
                isLoading={isSaveLoading}
              >
                {saveBtnTxt}
              </Button>
            </div>
          </div>
        )}
      </div>
    </ErrorBoundary>
  );
}

SettingsWrap.propTypes = {
  onSave: PropTypes.func,
  // onCancel: PropTypes.func,
  children: PropTypes.node,
  isSaveDisabled: PropTypes.bool,
  isSaveLoading: PropTypes.bool,
  header: PropTypes.string,
  goBack: PropTypes.func,
  settingsWrapper: PropTypes.string,
  xScroll: PropTypes.bool,
  layoutTwo: PropTypes.bool,
  saveBtnTxt: PropTypes.string,
  layoutThree: PropTypes.bool
};
